var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVLo7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0 0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-411 -1891)",
    stroke: "#FCBB00",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_7",
    transform: "translate(414 1894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2001835,51.147541 C26.5493289,48.4966864 24.9180328,44.8670556 24.9180328,40.8295999 C24.9180328,32.7546886 31.4432132,26.2295082 39.5181245,26.2295082 C43.5555802,26.2295082 47.185211,27.8608043 49.8360656,30.5116589 L29.2001835,51.147541 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9508197 14.7512954C56.038365 9.44934791 48.1384177 6.55737705 39.9619715 6.55737705 26.018563 6.55737705 13.0231483 14.9119603 3.97770775 29.371816.42273114 35.0352596.42273114 44.5546692 3.97770775 50.2181127 7.09818739 55.1987299 10.7321627 59.4965206 14.6821368 62.9508197M26.2295082 70.5327214C30.7041266 72.4202256 35.453502 73.442623 40.2813798 73.442623 54.1369965 73.442623 67.0505909 65.263438 76.0390787 51.1071561 79.5716721 45.5626124 79.5716721 36.2430576 76.0390787 30.6985139 74.7437944 28.6537176 73.3307517 26.7268911 71.8784632 24.9180328M53.7704918 41.9672131C52.6822465 47.868851 47.868851 52.6822465 41.9672131 53.7704918",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.164 49.836L0 80M80 0L49.836 30.164"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo7);
export default __webpack_public_path__ + "static/media/v_lo_7.de31e123c8d7134ee194a62c11b48ce3.svg";
export { ForwardRef as ReactComponent };